// extracted by css-extract-rspack-plugin
export default {"cls1":"SidebarComments-cls1_CWw","cls2":"SidebarComments-cls2_jMB SidebarComments-cls1_CWw"};